// extracted by mini-css-extract-plugin
export default {"priceWrapper":"styles_priceWrapper__Ule-B"};